import React from "react";
import "./alert.scss";

interface IAlert {
    children: React.ReactNode;
    type: "Info" | "Danger"
}

const Alert = ({children,type}:IAlert) => {
    return (
        <div className={`Alert Alert-${type}`}>
            <span>{children}</span>
        </div>
    );
}

export default Alert;